import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import PersianDatePicker from "../../../Events/NewRangePicker";
import { toJalaliString, getTodayRange } from "../../../../Utils/dateUtils";

const RangePickerEvents = ({ dateHOC, setDatesHOC, isPanel }) => {
  const lang_choiced = useSelector((state) => state.lang_change);
  const isMounted = useRef(true);
  
  // تبدیل تاریخ‌های ورودی به رشته شمسی
  const formatDateForState = (inputDates) => {
    if (!inputDates || !Array.isArray(inputDates) || inputDates.length !== 2) {
      return getTodayRange();
    }
    
    return [
      toJalaliString(inputDates[0]),
      toJalaliString(inputDates[1])
    ];
  };
  
  const [date, setDate] = useState(() => formatDateForState(dateHOC));
  
  // وقتی dateHOC از parent تغییر کرد
  useEffect(() => {
    if (dateHOC) {
      const formatted = formatDateForState(dateHOC);
      setDate(formatted);
    }
  }, [dateHOC]);
  
  // وقتی کامپوننت unmount میشه
  useEffect(() => {
    return () => {
      isMounted.current = false;
      // ریست به امروز
      if (setDatesHOC) {
        const todayRange = getTodayRange();
        setDatesHOC(todayRange);
      }
    };
  }, [setDatesHOC]);
  
  const handleRangeChange = (selectedDates) => {
    if (!selectedDates || selectedDates.length !== 2) return;
    
    // ذخیره رشته‌های شمسی
    setDate(selectedDates);
    
    // به parent بفرست
    if (setDatesHOC) {
      setDatesHOC(selectedDates);
    }
  };
  
  return (
    <div>
      <PersianDatePicker 
        dateHOC={date} 
        onRangeChange={handleRangeChange} 
      />
    </div>
  );
};

export default RangePickerEvents;